/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "../css/register.css";
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import { backend_url } from "../App.js";

// create new User account
function Register() {
    const navigate = useNavigate();

    // Setup data
    const [data, setData] = useState({
        password: "",
        email: "",
        verified: false
    })

    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setErrorMessage] = useState('');

    const handleChange = ({currentTarget: input }) => {
        setData({ ...data, [input.name]:input.value });
    }

    // Send post request to the user validation on submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        // Make sure the passwords match
        if (data.password !== confirmPassword) {
            setErrorMessage("Passwords do not match");
            return;
        } 
        else {
            try {

                //send post request to the 'api/resetPassword' endpoint, which resets the user's password
                const response = await axios.post(backend_url + 'users', data);
                const { data: { user } } = response;

                // User account created successfully
                if (response.status === 202) {
                    setErrorMessage("An email has been sent to you, please verify your account");
                }
                
            } 
            catch (error) {
                if (error.response && error.response.status >= 400 && error.response.status <= 500) {
                    setErrorMessage(error.response.data.message);
                }
            }
        }
    };

    //show or hide password
    const [state, setState] = useState(false);

    const toggleBtn = () => {
        setState(prevState => !prevState);
    }

    return (
        <>
            <>
                <meta charSet="UTF-8" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <title>Sign in/Sign Up</title>
                <link href='https://unpkg.com/boxicons@2.1.4/css/boxicons.min.css' rel='stylesheet' />
                <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;600;700&display=swap" rel="stylesheet" />
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" />
            </>

            <section className="container">
                <div className="form regis" id="regis">
                    <div className="form-content">
                        <header>Register</header>
                        {error && <div style={{color:"red", textAlign: "center", paddingTop: "15px"}}>{error}</div>}
                        <form action="#" onSubmit={handleSubmit}>
                            <div className="field input-field">
                                <label for="email" class="visuallyhidden">E-mail</label>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="input"
                                    name = "email"
                                    id="email"
                                    value={data.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="field input-field">
                                <label for="password" class="visuallyhidden">Password</label>
                                <input
                                    type={state ? "text" : "password"}
                                    placeholder="Password"
                                    className="password"
                                    name = "password"
                                    id="password"
                                    value={data.password}
                                    onChange={handleChange}
                                    required
                                />
                                <div onClick={toggleBtn}>
                                    <i className={state ? "bx bx-show eye-icon" : "bx bx-hide eye-icon"}></i>
                                </div>
                            </div>
                            <div className="field input-field">
                                <label for="confirmPassword" class="visuallyhidden">confirm password</label>
                                <input
                                    type={state ? "text" : "password"}
                                    placeholder="Confirm Password"
                                    className="password"
                                    name="confirmPassword"
                                    id="confirmPassword"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                />
                                <div onClick={toggleBtn}>
                                    <i className={state ? "bx bx-show eye-icon" : "bx bx-hide eye-icon"}></i>
                                </div>
                            </div>
                            <div>
                                <p id="pass-req">
                                    Passwords should:
                                    <ul>
                                        <li>Be between 8 and 26 characters long</li>
                                        <li>Contain at least one uppercase and lowercase character</li>
                                        <li>Contain at least one numeric value</li>
                                        <li>Contain at least one symbol</li>
                                    </ul>
                                </p>
                            </div>
                            <div className="field button-field">
                                <button type="submit">Register</button> 
                            </div>
                            <div className="form-link">
                                <span>Already have an account? <Link to="/" className="link login-link">Login</Link></span>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Register;